import React, { useEffect, useState } from "react";

import doctor01 from "../../assets/UserPanelAssets/img/doctors/doctor-01.jpg";
import doctor02 from "../../assets/UserPanelAssets/img/doctors/doctor-02.jpg";
import doctor03 from "../../assets/UserPanelAssets/img/doctors/doctor-03.jpg";
import doctor04 from "../../assets/UserPanelAssets/img/doctors/doctor-04.jpg";

import Tables from "../Components/UserPanelDataTables/tables";

export default function Doctors() {
  const [data, setData] = useState([]);
  useEffect(() => {
    setData({
      head: [
        { key: "doctorInfo", label: "Doctor Name" },
        { key: "phone", label: "Phone" },
        { key: "lastVisit", label: "Last Visit" },
        { key: "actions", label: "" },
      ],

      rows: [
        {
          doctorInfo: {
            doctorImage: doctor01,
            doctorName: "Dr. Alberto Ripley",
            specialty: "Cardiologist",
            doctorLink: "/patients-doctor-details",
          },
          phone: "+1 41245 54132",
          lastVisit: "30 Apr 2025",
          actions: [
            {
              label: "Appointment Settings",
              icon: "ti ti-calendar-cog",
              link: "/patient-appointment-details",
            },
            { label: "View Profile", type: "dropdown" },
            { label: "Edit", type: "dropdown" },
          ],
        },

        {
          doctorInfo: {
            doctorImage: doctor02,
            doctorName: "Dr. Sarah Johnson",
            specialty: "Orthopedic Surgeon",
            doctorLink: "/patients-doctor-details",
          },
          phone: "+1 65544 78966",
          lastVisit: "15 May 2025",
          actions: [
            {
              label: "Appointment Settings",
              icon: "ti ti-calendar-cog",
              link: "/patient-appointment-details",
            },
            { label: "View Profile", type: "dropdown" },
            { label: "Edit", type: "dropdown" },
          ],
        },

        {
          doctorInfo: {
            doctorImage: doctor03,
            doctorName: "Dr. Emily Carter",
            specialty: "Pediatrician",
            doctorLink: "/patients-doctor-details",
          },
          phone: "+1 78945 33211",
          lastVisit: "02 Jun 2025",
          actions: [
            {
              label: "Appointment Settings",
              icon: "ti ti-calendar-cog",
              link: "/patient-appointment-details",
            },
            { label: "View Profile", type: "dropdown" },
            { label: "Edit", type: "dropdown" },
          ],
        },

        {
          doctorInfo: {
            doctorImage: doctor04,
            doctorName: "Dr. David Lee",
            specialty: "Gynecologist",
            doctorLink: "/patients-doctor-details",
          },
          phone: "+1 99874 22131",
          lastVisit: "18 Jun 2025",
          actions: [
            {
              label: "Appointment Settings",
              icon: "ti ti-calendar-cog",
              link: "/patient-appointment-details",
            },
            { label: "View Profile", type: "dropdown" },
            { label: "Edit", type: "dropdown" },
          ],
        },
      ],
    });
  }, []);

  return (
    <div className="content">
      {/* Page Header */}
      <div className="d-flex align-items-sm-center flex-sm-row flex-column gap-2 pb-3 mb-3 border-1 border-bottom">
        <div className="flex-grow-1">
          <h4 className="fw-bold mb-0">Doctors</h4>
        </div>

        <div className="text-end">
          <div className="dropdown me-1">
            <a
              href="#!"
              className="btn btn-md fw-normal border fs-14 bg-white rounded text-dark d-inline-flex align-items-center"
              data-bs-toggle="dropdown"
            >
              Export <i className="ti ti-chevron-down ms-2"></i>
            </a>

            <ul className="dropdown-menu p-2">
              <li>
                <a className="dropdown-item" href="#!">
                  Download as PDF
                </a>
              </li>
              <li>
                <a className="dropdown-item" href="#!">
                  Download as Excel
                </a>
              </li>
            </ul>
          </div>
        </div>
      </div>

      {/* Search + Filters */}
      <div className="d-flex align-items-center justify-content-between flex-wrap row-gap-3">
        <div className="search-set mb-3">
          <div className="d-flex align-items-center flex-wrap gap-2">
            <div className="table-search d-flex align-items-center mb-0">
              <div className="search-input">
                <a href="#!" className="btn-searchset"></a>
              </div>
            </div>
          </div>
        </div>

        <div className="d-flex table-dropdown mb-3 pb-1 right-content align-items-center flex-wrap row-gap-3">
          {/* Filters Dropdown */}
          <div className="dropdown me-2">
            <a
              href="#!"
              className="bg-white border rounded btn btn-md text-dark fs-14 py-1 d-flex align-items-center fw-normal"
              data-bs-toggle="dropdown"
              data-bs-auto-close="outside"
            >
              <i className="ti ti-filter text-gray-5 me-1"></i> Filters
            </a>

            <div className="dropdown-menu dropdown-lg dropdown-menu-end filter-dropdown p-0">
              <div className="d-flex align-items-center justify-content-between border-bottom filter-header">
                <h4 className="mb-0 fw-bold">Filter</h4>
                <div>
                  <a
                    href="#!"
                    className="link-danger text-decoration-underline"
                  >
                    Clear All
                  </a>
                </div>
              </div>

              <form>
                <div className="filter-body pb-0">
                  {/* Doctor */}
                  <div className="mb-3">
                    <div className="d-flex align-items-center justify-content-between">
                      <label className="form-label mb-1">Doctor</label>
                      <a href="#!" className="link-primary mb-1">
                        Reset
                      </a>
                    </div>

                    <select className="select2" multiple>
                      <option value="m-1">Dr. Mick Thompson</option>
                      <option value="m-2">Dr. Sarah Johnson</option>
                      <option value="m-3">Dr. Emily Carter</option>
                      <option value="m-4">Dr. David Lee</option>
                      <option value="m-5">Dr. Anna Kim</option>
                    </select>
                  </div>

                  {/* Designation */}
                  <div className="mb-3">
                    <div className="d-flex align-items-center justify-content-between">
                      <label className="form-label">Designation</label>
                      <a href="#!" className="link-primary mb-1">
                        Reset
                      </a>
                    </div>

                    <select className="select2" multiple>
                      <option value="m-1">Cardiologist</option>
                      <option value="m-2">Orthopedic Surgeon</option>
                      <option value="m-3">Pediatrician</option>
                      <option value="m-4">Gynecologist</option>
                    </select>
                  </div>

                  {/* Department */}
                  <div className="mb-3">
                    <div className="d-flex align-items-center justify-content-between">
                      <label className="form-label">Department</label>
                      <a href="#!" className="link-primary mb-1">
                        Reset
                      </a>
                    </div>

                    <select className="select2" multiple>
                      <option value="m-1">Cardiology</option>
                      <option value="m-2">Orthopedics</option>
                      <option value="m-3">Pediatrics</option>
                    </select>
                  </div>

                  {/* Date */}
                  <div className="mb-3">
                    <label className="form-label mb-1 text-dark fs-14 fw-medium">
                      Date <span className="text-danger">*</span>
                    </label>

                    <div className="input-icon-end position-relative">
                      <input
                        type="text"
                        className="form-control datetimepicker"
                        placeholder="dd/mm/yyyy"
                      />
                      <span className="input-icon-addon">
                        <i className="ti ti-calendar"></i>
                      </span>
                    </div>
                  </div>

                  {/* Amount */}
                  <div className="mb-3">
                    <div className="d-flex align-items-center justify-content-between">
                      <label className="form-label">Amount</label>
                      <a href="#!" className="link-primary mb-1">
                        Reset
                      </a>
                    </div>
                    <select className="select2" multiple>
                      <option value="m-1">$501 - $1000</option>
                      <option value="m-2">$501 - $1100</option>
                      <option value="m-3">$701 - $1200</option>
                    </select>
                  </div>

                  {/* Status */}
                  <div className="mb-3">
                    <div className="d-flex align-items-center justify-content-between">
                      <label className="form-label">Status</label>
                      <a href="#!" className="link-primary mb-1">
                        Reset
                      </a>
                    </div>
                    <select className="select2" multiple>
                      <option value="m-1">Available</option>
                      <option value="m-2">Unavailable</option>
                    </select>
                  </div>
                </div>

                <div className="filter-footer d-flex align-items-center justify-content-end border-top">
                  <a href="#!" className="btn btn-light btn-md me-2 fw-medium">
                    Close
                  </a>
                  <button
                    type="submit"
                    className="btn btn-primary btn-md fw-medium"
                  >
                    Filter
                  </button>
                </div>
              </form>
            </div>
          </div>

          {/* Sort Dropdown */}
          <div className="dropdown">
            <a
              href="#!"
              className="dropdown-toggle btn bg-white btn-md d-inline-flex align-items-center fw-normal rounded border text-dark px-2 py-1 fs-14"
              data-bs-toggle="dropdown"
            >
              <span className="me-1">Sort By :</span> Recent
            </a>

            <ul className="dropdown-menu dropdown-menu-end p-2">
              <li>
                <a href="#!" className="dropdown-item rounded-1">
                  Recently Added
                </a>
              </li>
              <li>
                <a href="#!" className="dropdown-item rounded-1">
                  Ascending
                </a>
              </li>
              <li>
                <a href="#!" className="dropdown-item rounded-1">
                  Descending
                </a>
              </li>
              <li>
                <a href="#!" className="dropdown-item rounded-1">
                  Last Month
                </a>
              </li>
              <li>
                <a href="#!" className="dropdown-item rounded-1">
                  Last 7 Days
                </a>
              </li>
            </ul>
          </div>
        </div>
      </div>

      {/* Table */}
      <Tables data={data} />
    </div>
  );
}
